function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import { GALLERY_CONSTS } from 'pro-gallery-lib';
import LoveButton from '../loveButton/LoveButton.js';
import ShareStoreIcon from '../svgs/components/share_store';
import Download from '../download/Download';

var Social = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Social, _React$Component);

  function Social() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Social.prototype;

  _proto.getSocialShare = function getSocialShare() {
    var _this$props = this.props,
        options = _this$props.options,
        id = _this$props.id,
        actions = _this$props.actions;

    if (options.allowSocial) {
      var shareButton = /*#__PURE__*/React.createElement("i", {
        className: 'share-store'
      }, /*#__PURE__*/React.createElement(ShareStoreIcon, null));
      var socialShareClassName = 'info-member info-element-social-share info-element-social-button';

      if (this.props.viewMode === GALLERY_CONSTS.viewMode.SITE || this.props.viewMode === GALLERY_CONSTS.viewMode.SEO) {
        var slideshowShare = !this.props.shouldUseNewSocialSharePopup && GALLERY_CONSTS.isLayout('SLIDESHOW')(options) ? actions.getShare() : '';
        return /*#__PURE__*/React.createElement("div", {
          className: socialShareClassName,
          "data-hook": "info-element-social-button",
          key: 'item-social-share-' + id,
          onClick: function onClick(e) {
            return actions.toggleShare(e, true);
          }
        }, shareButton, slideshowShare);
      } else {
        return /*#__PURE__*/React.createElement("div", {
          className: socialShareClassName,
          "data-hook": "info-element-social-button",
          key: 'item-social-share-' + id,
          onClick: function onClick(e) {
            e.stopPropagation();
            e.preventDefault();
          }
        }, shareButton);
      }
    }

    return '';
  };

  _proto.getLoveButton = function getLoveButton() {
    var _this$props2 = this.props,
        options = _this$props2.options,
        isNarrow = _this$props2.isNarrow,
        isSmallItem = _this$props2.isSmallItem;
    return options.loveButton ? /*#__PURE__*/React.createElement(LoveButton, _extends({}, this.props, {
      itemId: this.props.photoId,
      showCounter: options.loveCounter && !isSmallItem && !isNarrow
    })) : null;
  };

  _proto.getDownload = function getDownload() {
    var _this$props3 = this.props,
        options = _this$props3.options,
        isDemo = _this$props3.isDemo,
        viewMode = _this$props3.viewMode;

    if (options.allowDownload && !((viewMode === GALLERY_CONSTS.viewMode.SITE || viewMode === GALLERY_CONSTS.viewMode.SEO) && isDemo)) {
      return /*#__PURE__*/React.createElement(Download, this.props);
    }

    return null;
  };

  _proto.render = function render() {
    var _this$props4 = this.props,
        options = _this$props4.options,
        id = _this$props4.id,
        showShare = _this$props4.showShare,
        isSmallItem = _this$props4.isSmallItem,
        isNarrow = _this$props4.isNarrow,
        isShort = _this$props4.isShort,
        isVerticalContainer = _this$props4.isVerticalContainer;
    var socialShare = this.getSocialShare();
    var loveButton = this.getLoveButton();
    var download = this.getDownload(); // var shopIcons = this.getShopIcons();

    var isShowArrows = options.hasThumbnails;
    var isPopulated = options.allowSocial || options.loveButton || options.allowDownload;
    var textPlacementAboveOrBelowOrRightOrLeft = GALLERY_CONSTS.hasExternalHorizontalPlacement(options.titlePlacement) || GALLERY_CONSTS.hasExternalVerticalPlacement(options.titlePlacement);
    var classes = [[showShare, 'hidden'], [isSmallItem, 'small-item'], [isShort, 'short-item'], [isNarrow, 'narrow-item'], [isVerticalContainer, 'vertical-item'], [isShowArrows, 'with-arrows'], [isPopulated, 'populated-item'], [textPlacementAboveOrBelowOrRightOrLeft, 'text-external-item']].filter(function (x) {
      return x[0];
    }).map(function (x) {
      return x[1];
    }).join(' ');
    return /*#__PURE__*/React.createElement("div", {
      className: 'info-element-social info-align-' + options.galleryTextAlign + ' ' + classes,
      key: 'item-social-' + id,
      "data-hook": "item-social"
    }, loveButton, download, socialShare);
  };

  return Social;
}(React.Component);

export { Social as default };